/* Blog Carousel.

   In the theme: assets/nextdev-blog-posts.js, loaded by
   sections/nextdev-blog-posts.liquid. Elements are looked up by the
   data-nextdev-bp-* attributes beside the nextdev--blog-posts__* classes.

   The row scrolls by itself under a finger or a trackpad; this adds the
   arrows, which move it a view at a time, and a dot for every view, which
   says where it is. With everything in one view there are neither. */
(function () {
  'use strict';

  function setup(root) {
    if (root.dataset.nextdevBlogPostsInit) return;
    var track = root.querySelector('[data-nextdev-bp-track]');
    var nav = root.querySelector('[data-nextdev-bp-nav]');
    if (!track || !nav) return;
    root.dataset.nextdevBlogPostsInit = '1';

    var prev = nav.querySelector('[data-nextdev-bp-prev]');
    var next = nav.querySelector('[data-nextdev-bp-next]');
    var dotsBox = nav.querySelector('[data-nextdev-bp-dots]');
    var dots = [];
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // a view is the cards' width inside the row's inset, plus the gap after
    // its last card
    function views() {
      if (!track.clientWidth) return 1;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap) || 0;
      var inside = track.clientWidth - (parseFloat(style.paddingLeft) || 0) - (parseFloat(style.paddingRight) || 0);
      var room = track.scrollWidth - track.clientWidth;
      return room > 1 ? 1 + Math.ceil((room - 1) / (inside + gap)) : 1;
    }

    function current() {
      var room = track.scrollWidth - track.clientWidth;
      if (room <= 0) return 0;
      return Math.round((track.scrollLeft / room) * (views() - 1));
    }

    function goTo(i) {
      var room = track.scrollWidth - track.clientWidth;
      var n = views();
      var left = n > 1 ? (room * i) / (n - 1) : 0;
      track.scrollTo({ left: left, behavior: reduced ? 'auto' : 'smooth' });
    }

    function draw() {
      var n = views();
      nav.hidden = n < 2;
      if (dots.length !== n) {
        dotsBox.textContent = '';
        dots = [];
        for (var i = 0; i < n; i += 1) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'nextdev--blog-posts__dot';
          dot.setAttribute('aria-label', 'Posts, view ' + (i + 1) + ' of ' + n);
          dot.addEventListener('click', goTo.bind(null, i));
          dotsBox.appendChild(dot);
          dots.push(dot);
        }
      }
      mark();
    }

    function mark() {
      var at = current();
      for (var i = 0; i < dots.length; i += 1) {
        dots[i].classList.toggle('nextdev--blog-posts__dot--on', i === at);
        dots[i].setAttribute('aria-current', i === at ? 'true' : 'false');
      }
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
    }

    prev.addEventListener('click', function () { goTo(Math.max(0, current() - 1)); });
    next.addEventListener('click', function () { goTo(Math.min(views() - 1, current() + 1)); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(mark); }, { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(draw).observe(track);
    } else {
      window.addEventListener('resize', draw);
    }
    draw();
  }

  function init() {
    var roots = document.querySelectorAll('[data-nextdev-blog-posts]');
    for (var i = 0; i < roots.length; i += 1) setup(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // the theme editor swaps the section out and back in
  document.addEventListener('shopify:section:load', init);
})();
